import baseUrlUtil from 'util/base-url-util';

import type { PropsWithChildren } from 'react';

import config from 'config/config';
import { PostHogProvider } from 'posthog-js/react';

const PostHogProviderWrapper = ({ children }: PropsWithChildren<{}>) => {
  if (window.location.host.includes('localhost')) return <>{children}</>;
  if (!config.postHog.apiHost) return <>{children}</>;
  return (
    <PostHogProvider
      apiKey={config.postHog.apiKey}
      options={{
        api_host: config.postHog.apiHost,
        autocapture: false,
        enable_recording_console_log: true,
        name: baseUrlUtil.getBaseUrl()
      }}
    >
      {children}
    </PostHogProvider>
  );
};
export default PostHogProviderWrapper;
